import React, { type FC } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress } from '@mui/material'

import { Translation } from '../../../domain'

import { LogoutReason } from '../../../application'

import { Button, Validation } from '../common'
import { FormattedTranslation } from '../Internationalization'
import { useAppUsecase } from '../State'

export const SessionToken: FC = () => {
    const usecase = useAppUsecase('loginFromTokenUsecase')

    return (
        <Dialog disableEscapeKeyDown open>
            <DialogTitle>
                <FormattedTranslation id={Translation.TOKEN_ERROR_DIALOG_TITLE} />
            </DialogTitle>
            <LinearProgress variant="determinate" value={0} />
            <DialogContent>
                <Validation error labelVariant="body1">
                    <FormattedTranslation id={Translation.TOKEN_ERROR_DIALOG_CONTENT} />
                </Validation>
            </DialogContent>
            <DialogActions>
                <Button variant="primary" onClick={() => usecase.logout(LogoutReason.MANUAL_LOGOUT)}>
                    <FormattedTranslation id={Translation.BACK_TO_LOGIN} />
                </Button>
            </DialogActions>
        </Dialog>
    )
}
